module.exports = __webpack_public_path__ + "img/任意拉伸.eadf527e.svg";